"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeComponents = exports.Plural = exports.Singular = exports.Param = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["children", "context", "as"],
    _excluded2 = ["count", "context", "as"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Param = /*#__PURE__*/function (_React$Component) {
  _inherits(Param, _React$Component);

  var _super = _createSuper(Param);

  function Param() {
    _classCallCheck(this, Param);

    return _super.apply(this, arguments);
  }

  _createClass(Param, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          wrapper = _this$props.wrapper,
          value = _this$props.value,
          children = _this$props.children;
      return wrapper ? _react.default.cloneElement(wrapper, {}, value !== undefined ? value : children) : value;
    }
  }]);

  return Param;
}(_react.default.Component);

exports.Param = Param;

_defineProperty(Param, "propTypes", {
  // eslint-disable-next-line react/no-unused-prop-types
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.any,
  wrapper: _propTypes.default.element,
  children: _propTypes.default.string
});

_defineProperty(Param, "defaultProps", {
  value: undefined,
  wrapper: undefined,
  children: undefined
});

var collapseWhitespace = function collapseWhitespace(string) {
  // for translated strings we never want consecutive or surrounding whitespace
  return string.replace(/\s+/g, ' ').trim();
};

var getTranslatableString = function getTranslatableString(children) {
  var usedParams = new Set();

  var items = _react.default.Children.map(children, function (child) {
    if (!_react.default.isValidElement(child)) {
      // plain value, nothing to change here
      if (typeof child !== 'string') {
        throw new Error("Unexpected Translate child type: ".concat(_typeof(child)));
      }

      return child;
    } else if (child.type !== Param) {
      throw new Error("Translate child components must be of type Param; got ".concat(child.type.name));
    } else {
      var _child$props = child.props,
          paramName = _child$props.name,
          paramValue = _child$props.value;
      var paramContent = child.props.children;

      if (usedParams.has(paramName)) {
        throw new Error("Translate params must be unique; found ".concat(paramName, " more than once"));
      } else if (Array.isArray(paramContent)) {
        paramContent = paramContent.join('');
      } else if (paramContent !== undefined && typeof paramContent !== 'string') {
        throw new Error("Unexpected Param child type: ".concat(_typeof(paramContent)));
      } else if (paramContent === undefined && paramValue === undefined) {
        throw new Error("Param has no value nor children");
      }

      usedParams.add(paramName);
      return paramContent === undefined ? "{".concat(paramName, "}") : "{".concat(paramName, "}").concat(paramContent, "{/").concat(paramName, "}");
    }
  });

  return collapseWhitespace(items.join(''));
};

var jsonToReact = function jsonToReact(values, component, props) {
  /* eslint-disable react/prop-types */
  component = {
    Fragment: _react.default.Fragment,
    Param: Param
  }[component];

  if (component === Param) {
    // inject the value from the original Param in the translated string's Param
    props = _objectSpread(_objectSpread({}, props), values[props.name]);
  }

  for (var _len = arguments.length, children = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    children[_key - 3] = arguments[_key];
  }

  return _react.default.createElement.apply(_react.default, [component, props].concat(_toConsumableArray(children.map(function (child) {
    return typeof child === 'string' ? child : jsonToReact.apply(void 0, [values].concat(_toConsumableArray(child)));
  }))));
};

var renderTranslation = function renderTranslation(translation, values) {
  if (typeof translation === 'string') {
    return translation;
  } else {
    return jsonToReact.apply(void 0, [values].concat(_toConsumableArray(translation)));
  }
};

var jsonToText = function jsonToText(values, component, props) {
  for (var _len2 = arguments.length, children = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
    children[_key2 - 3] = arguments[_key2];
  }

  if (component === 'Param') {
    if (children.length) {
      throw new Error('Placeholders with content are not supported in string()');
    } else {
      if (!Object.prototype.hasOwnProperty.call(values, props.name)) {
        throw new Error("Placeholder '{".concat(props.name, "}' got no value"));
      }

      return values[props.name];
    }
  }

  return children.map(function (child) {
    return typeof child === 'string' ? child : jsonToText.apply(void 0, [values].concat(_toConsumableArray(child)));
  }).join('');
};

var interpolateValues = function interpolateValues(string, values) {
  return string.replace(/{([^}]+)}/g, function (match, name) {
    if (!Object.prototype.hasOwnProperty.call(values, name)) {
      throw new Error("Placeholder '{".concat(name, "}' got no value"));
    }

    return values[name];
  });
};

var renderStringTranslation = function renderStringTranslation(translation, values) {
  if (typeof translation === 'string') {
    return interpolateValues(translation, values);
  } else {
    return jsonToText.apply(void 0, [values].concat(_toConsumableArray(translation)));
  }
};

var Singular = /*#__PURE__*/function (_React$Component2) {
  _inherits(Singular, _React$Component2);

  var _super2 = _createSuper(Singular);

  function Singular() {
    _classCallCheck(this, Singular);

    return _super2.apply(this, arguments);
  }

  _createClass(Singular, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children;
    }
  }]);

  return Singular;
}(_react.default.Component);

exports.Singular = Singular;

_defineProperty(Singular, "propTypes", {
  children: _propTypes.default.any.isRequired
});

var Plural = /*#__PURE__*/function (_React$Component3) {
  _inherits(Plural, _React$Component3);

  var _super3 = _createSuper(Plural);

  function Plural() {
    _classCallCheck(this, Plural);

    return _super3.apply(this, arguments);
  }

  _createClass(Plural, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children;
    }
  }]);

  return Plural;
}(_react.default.Component);

exports.Plural = Plural;

_defineProperty(Plural, "propTypes", {
  children: _propTypes.default.any.isRequired
});

var getGettextFuncs = function getGettextFuncs(args) {
  var gettext, ngettext, pgettext, npgettext;

  if (args.length === 1) {
    var _args = _slicedToArray(args, 1),
        obj = _args[0];

    gettext = obj.gettext.bind(obj);
    ngettext = obj.ngettext.bind(obj);
    pgettext = obj.pgettext ? obj.pgettext.bind(obj) : undefined;
    npgettext = obj.npgettext ? obj.npgettext.bind(obj) : undefined;
  } else if (args.length === 2) {
    var _args2 = _slicedToArray(args, 2);

    gettext = _args2[0];
    ngettext = _args2[1];
  } else if (args.length === 4) {
    var _args3 = _slicedToArray(args, 4);

    gettext = _args3[0];
    ngettext = _args3[1];
    pgettext = _args3[2];
    npgettext = _args3[3];
  } else {
    throw new Error('Expected object containing gettext/ngettext(/pgettext/npgattext) or 2/4 args with the funcs');
  }

  if (!pgettext) {
    pgettext = function pgettext(ctx) {
      for (var _len3 = arguments.length, params = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        params[_key3 - 1] = arguments[_key3];
      }

      return gettext.apply(void 0, params);
    };
  }

  if (!npgettext) {
    npgettext = function npgettext(ctx) {
      for (var _len4 = arguments.length, params = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        params[_key4 - 1] = arguments[_key4];
      }

      return ngettext.apply(void 0, params);
    };
  }

  return {
    gettext: gettext,
    ngettext: ngettext,
    pgettext: pgettext,
    npgettext: npgettext
  };
};

var pickGettextFunc = function pickGettextFunc(context, gettext, pgettext) {
  if (context) {
    return function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return pgettext.apply(void 0, [context].concat(args));
    };
  } else {
    return gettext;
  }
};

var getParamValues = function getParamValues(element) {
  var obj = Object.create(null);

  _react.default.Children.forEach(element.props.children, function (child) {
    if (_react.default.isValidElement(child) && child.type === Param) {
      obj[child.props.name] = {
        value: child.props.value,
        wrapper: child.props.wrapper
      };
    }
  });

  return obj;
};

var getContextParams = function getContextParams(args) {
  if (args.length === 0) {
    return {
      context: undefined,
      params: {}
    };
  } else if (args.length === 1) {
    if (_typeof(args[0]) === 'object') {
      return {
        context: undefined,
        params: args[0]
      };
    } else {
      return {
        context: args[0],
        params: {}
      };
    }
  } else {
    return {
      context: args[0],
      params: args[1]
    };
  }
};

var makeComponents = function makeComponents() {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  var _getGettextFuncs = getGettextFuncs(args),
      gettext = _getGettextFuncs.gettext,
      ngettext = _getGettextFuncs.ngettext,
      pgettext = _getGettextFuncs.pgettext,
      npgettext = _getGettextFuncs.npgettext;

  var Translate = /*#__PURE__*/function (_React$Component4) {
    _inherits(Translate, _React$Component4);

    var _super4 = _createSuper(Translate);

    function Translate(props) {
      var _this;

      _classCallCheck(this, Translate);

      _this = _super4.call(this, props);
      _this.original = getTranslatableString(props.children);
      return _this;
    }

    _createClass(Translate, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            children = _this$props2.children,
            context = _this$props2.context,
            as = _this$props2.as,
            rest = _objectWithoutProperties(_this$props2, _excluded);

        var gettextFunc = pickGettextFunc(context, gettext, pgettext);
        var translation = gettextFunc(this.original);
        var content = children;

        if (translation !== this.original) {
          content = renderTranslation(translation, getParamValues(this));
        } // if there's no translation gettext gives us the input string
        // which does not contain the information needed to render it!
        // unfortunately this means that we also cannot strip surrounding
        // whitespace since we may have more than just text in the children,
        // which is why we fail during extraction in that case


        return _react.default.createElement(as, rest, content);
      }
    }], [{
      key: "string",
      value: // eslint-disable-next-line no-shadow, react/sort-comp
      function string(_string) {
        for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
          args[_key7 - 1] = arguments[_key7];
        }

        var _getContextParams = getContextParams(args),
            context = _getContextParams.context,
            params = _getContextParams.params;

        var gettextFunc = pickGettextFunc(context, gettext, pgettext);
        return renderStringTranslation(gettextFunc(collapseWhitespace(_string)), params);
      }
    }]);

    return Translate;
  }(_react.default.Component);

  _defineProperty(Translate, "propTypes", {
    children: _propTypes.default.any.isRequired,
    context: _propTypes.default.string,
    as: _propTypes.default.elementType
  });

  _defineProperty(Translate, "defaultProps", {
    context: undefined,
    as: _react.default.Fragment
  });

  var PluralTranslate = /*#__PURE__*/function (_React$Component5) {
    _inherits(PluralTranslate, _React$Component5);

    var _super5 = _createSuper(PluralTranslate);

    function PluralTranslate(props) {
      var _this2;

      _classCallCheck(this, PluralTranslate);

      _this2 = _super5.call(this, props);

      _react.default.Children.forEach(props.children, function (child) {
        if (!_react.default.isValidElement(child)) {
          throw new Error("Unexpected PluralTranslate child: ".concat(child));
        } else if (child.type === Singular) {
          _this2.singularString = getTranslatableString(child.props.children);
        } else if (child.type === Plural) {
          _this2.pluralString = getTranslatableString(child.props.children);
        }
      });

      return _this2;
    }

    _createClass(PluralTranslate, [{
      key: "getChild",
      value: function getChild(plural) {
        var children = this.props.children;
        var component = plural ? Plural : Singular;

        var _iterator = _createForOfIteratorHelper(_react.default.Children.toArray(children)),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var child = _step.value;

            if (_react.default.isValidElement(child) && child.type === component) {
              return child;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props3 = this.props,
            count = _this$props3.count,
            context = _this$props3.context,
            as = _this$props3.as,
            rest = _objectWithoutProperties(_this$props3, _excluded2);

        var gettextFunc = pickGettextFunc(context, ngettext, npgettext);
        var translation = gettextFunc(this.singularString, this.pluralString, count);
        var content;

        if (translation === this.singularString) {
          content = this.getChild(false);
        } else if (translation === this.pluralString) {
          content = this.getChild(true);
        } else {
          var values = getParamValues(this.getChild(count !== 1));
          content = renderTranslation(translation, values);
        }

        return _react.default.createElement(as, rest, content);
      }
    }], [{
      key: "string",
      value: // eslint-disable-next-line no-shadow
      function string(singular, plural) {
        var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

        for (var _len8 = arguments.length, args = new Array(_len8 > 3 ? _len8 - 3 : 0), _key8 = 3; _key8 < _len8; _key8++) {
          args[_key8 - 3] = arguments[_key8];
        }

        var _getContextParams2 = getContextParams(args),
            context = _getContextParams2.context,
            params = _getContextParams2.params;

        var gettextFunc = pickGettextFunc(context, ngettext, npgettext);
        return renderStringTranslation(gettextFunc(collapseWhitespace(singular), collapseWhitespace(plural), count), params);
      }
    }]);

    return PluralTranslate;
  }(_react.default.Component);

  _defineProperty(PluralTranslate, "propTypes", {
    children: _propTypes.default.any.isRequired,
    count: _propTypes.default.number.isRequired,
    context: _propTypes.default.string,
    as: _propTypes.default.elementType
  });

  _defineProperty(PluralTranslate, "defaultProps", {
    context: undefined,
    as: _react.default.Fragment
  });

  return {
    Translate: Translate,
    PluralTranslate: PluralTranslate
  };
};

exports.makeComponents = makeComponents;